export default {
  independentMarketing: {
    common: {
      requestFailed: 'Interfaceverzoek mislukt',
      hintSelect: 'Selecteer',
      hintInput: 'Binnenkomen',
      submit: 'Indienen',
      cancel: 'Annuleren',
      confirm: 'OK',
    },
    agreement: {
      title: 'Registratieovereenkomst voor onafhankelijke Autel-dealers',
      nextBtn: 'Volgende',
      getAgreementFailed: 'Kan de inhoud van de overeenkomst niet ophalen.',
    },
    successPage: {
      title:
        'Uw aanvraaggegevens zijn succesvol verzonden en de beoordelingsresultaten worden binnen 15 werkdagen naar uw e-mailadres $1 verzonden. Controleer uw inbox voor meer informatie.',
      subTitle: 'Keer na $1 seconde(n) terug naar de startpagina.',
    },
    applyTitle: 'U solliciteert om onafhankelijk Autel-dealer te worden. Vul de volgende gegevens nauwkeurig in:',
    companyName: 'Bedrijfsnaam',
    companyTax: 'VAT ID',
    userCountry: 'Land',
    legalPerson: 'Rechtsbijstand',
    contactEmail: 'Contact email',
    contactEmailTips:
      'Dit e-mailadres is uw contactpersoon voor de e-mail met het beoordelingsresultaat. Zodra de beoordeling is goedgekeurd, wordt deze ook gebruikt als login-accountnaam voor het onafhankelijke dealerbeheersysteem.',
    corporateIdentity: 'Juridisch adviseur-ID',
    uploadTips: 'JPG, JPEG, PNG, PDF (niet groter dan 20 MB)',
    businessLicense: 'Zakelijke licentie',
    emailErrorTips: 'Vul een geldig e-mailadres in.',
    uploadPic: 'Upload afbeeldingen',
    picMaxLimit: 'De maximale afbeeldingsgrootte is 20 MB. Selecteer opnieuw.',
  },
};
